
const utils       		    = require('../lib/utils')
const appConfig       		= require('./config').getConfig()
const etagResourceHandler   = require('./etagResourceHandler')
const heartbeatConfig       = Object.freeze(appConfig.heartbeatConfig || {})


/**
 * handles heartbeat connection
 * @constructor
 */
function HeartbeatController(storage){
    this.storage = storage
    this.connected = false
    this.eventSource = null
    this.connect()
}

/**
 * handle connection state
 *
 * @param connected  boolean - connected
 */
HeartbeatController.prototype.stateChanged = function(connected){
    this.connected = !!connected

    if((this.storage || {}).componentTree){
        this.storage.componentTree.callHandler(null, 'heartbeat.connectionStateChanged', [this.connected])
    }

    if(this.connecting){
        if(this.connected)  this.connecting.resolve();
        else                this.connecting.reject();
        delete this.connecting
    }
}

/**
 * reconnect heartbeat if necessary and tell everyone afterwards if necessary
 *
 * @param [forceResourceChanged=false]      boolean - trigger reconnect message if connection already established anyway
 * @returns {Promise<void>}
 */
HeartbeatController.prototype.reconnect = async function(forceResourceChanged = false){
    try {
        if(!this.connected && !this.connecting){
            await this.connect()
            forceResourceChanged = true
        }
        if(forceResourceChanged){
            await this.processMessage({ type: 'reconnect' })
        }
    } catch (error) {
        console.error('reconnect not possible', error)
    }
}

/**
 * connect heartbeat
 *
 * @returns {Promise<Window.Promise>}
 */
HeartbeatController.prototype.connect = async function(){
    if(!heartbeatConfig.turnedOn){
        return
    }
    if(appConfig.heartbeatConfig.authenticatedClientsOnly && !((((this.storage || {}).user || {}).data || {}).states || {}).authenticated){
        return
    }
    if(this.connecting){
        return
    }

    this.connecting = utils.promise.newCustom(this)

    if(this.eventSource){
        this.eventSource.close()
    }

    this.eventSource = new EventSource('/LTR/~/heartbeat', { withCredentials: false })

    this.eventSource.onopen = async event => {
        this.stateChanged(true)
    }
    this.eventSource.onerror = async event => {
        this.stateChanged(false)
    }
    this.eventSource.onmessage = async event => {
        // server want's me to close this connection for now.
        if(event.data === 'close'){
            this.stateChanged(false)
            this.eventSource.close()
            return
        }

        // dummy message needed to trigger onopen
        if(event.data === 'connected'){
            return
        }

        this.processMessage(JSON.parse(event.data || '{}'))
    }

    return this.connecting
}

/**
 * process heartbeat message
 *
 * @param message   {} - heartbeat message
 *                  format = {
 *                      type: '',
 *                      subType: '',
 *                      data: {<someData sent by the server>},
 *                  }
 * @returns {Promise<void>}
 */
HeartbeatController.prototype.processMessage = async function(message){
    if(!message) return;
    if(!this.connected) return;

    const componentTree = (this.storage || {}).componentTree
    let heartbeatPrewarmedResourceHashes = {}
    const keys = [message.type || 'UNKNOWN']
    if(message.subType) keys.push(message.subType);
    message.heartbeatKey = keys.join('.')
    message.data = message.data || {}

    if(message.type){

        // prewarm registered resources
        if(message.type === 'resourceChanged' && message.subType){
            heartbeatPrewarmedResourceHashes = await etagResourceHandler.prewarmHeartbeat(message.heartbeatKey)
        }

        // call heartbeat handlers
        if(componentTree){
            componentTree.callHandler(null, `heartbeat.${message.type}`, [message, heartbeatPrewarmedResourceHashes || {}])
        }

    }
}

module.exports = HeartbeatController